import { useMutation } from '@tanstack/react-query'

import { Methods } from '@/api/v1/orders/approve'
import { orderKeyFactory } from '@/hooks/features/order/key'
import { orderHistoryKeyFactory } from '@/hooks/features/orderHistory/key'
import { aspidaClient } from '@/lib/aspida'
import { queryClient } from '@/lib/react-query'
import { MutationConfig } from '@/lib/react-query'

export type ApproveOrdersDTO = {
  data: Methods['patch']['reqBody']
}

export const approveOrders = ({ data }: ApproveOrdersDTO) => {
  return aspidaClient.v1.orders.approve.$patch({ body: data })
}

type UseApproveOrdersOptions = {
  config?: MutationConfig<typeof approveOrders>
  invalidateTarget: 'order' | 'orderHistory'
}

export const useApproveOrders = ({
  config,
  invalidateTarget,
}: UseApproveOrdersOptions) => {
  return useMutation({
    onSuccess: () =>
      queryClient.invalidateQueries(
        invalidateTarget === 'order'
          ? orderKeyFactory.all
          : orderHistoryKeyFactory.all
      ),
    ...config,
    mutationFn: approveOrders,
  })
}
